// This SDK supports both Next.js Pages Router and App Router.
// 'use client' is required for App Router compatibility; it is a no-op in Pages Router.
'use client'

import { useMutation, type UseMutationOptions, type UseMutationResult } from '@tanstack/react-query'

export function useHttpMutation<TData = unknown, TError = Error, TVariables = void>(
  options: UseMutationOptions<TData, TError, TVariables>,
): UseMutationResult<TData, TError, TVariables> {
  return useMutation<TData, TError, TVariables>(options)
}
